/**
 * Test IDs for Header component elements
 * This library provides a centralized way to generate test IDs for header elements
 * to ensure consistency between the component and tests.
 */
export const headerTestIds = {
  /**
   * Test ID for the debug sidebar toggle button
   */
  debugSidebarToggle: 'header-debug-sidebar-toggle',

  /**
   * Test ID for the copy room button
   */
  copyRoomButton: 'header-copy-room-button',

  /**
   * Test ID for the leave room button
   */
  leaveRoomButton: 'header-leave-room-button',

  /**
   * Test ID for the share dialog content
   */
  shareDialog: 'header-share-dialog',

  /**
   * Test ID for the copy-link button inside the share dialog
   */
  shareDialogCopyButton: 'header-share-dialog-copy-button',

  /**
   * Test ID for the read-only room URL field inside the share dialog
   */
  shareDialogUrlInput: 'header-share-dialog-url-input',

  /**
   * Test ID for the header element itself
   */
  header: 'header',

  /**
   * Test ID for the game name heading (h2)
   */
  gameName: 'header-game-name',

  /**
   * Test ID for the gameless mode toggle button
   */
  gamelessToggleButton: 'header-gameless-toggle-button',
} as const

